import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import _ from 'lodash'

import Well from '@react/react-spectrum/Well'
import Heading from '@react/react-spectrum/Heading'

import { RootContext } from '../../../root/RootContext'
import { ProfileContext } from '../../../root/ProfileContext'
import './ProcessFlow.scss'
import LinearProcess from '../../../components/LinearProcess/LinearProcess'

export default function ProcessFlow({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const rootContext = useContext(RootContext)
  const currentProfile = profileContext.state.currentProfile
  const stepEventTypes = content.steps?.map((s) => s.eventType)

  const [profileSteps, setProfileSteps] = useState()

  useEffect(() => {
    if (currentProfile) {
      let ee = currentProfile?.experienceEvents.sort((a, b) => a.timestamp - b.timestamp)
      ee = _.filter(ee, (e) => _.includes(stepEventTypes, _.get(e, 'entity.eventType')))
      setProfileSteps(ee)
    }
  }, [currentProfile])

  return (
    <div className='profile-module process-flow'>
      <div className='module-content'>
        {currentProfile && currentProfile.experienceEvents && (
          <>
            {content.description && <Well>{content.description}</Well>}
            <LinearProcess configSteps={content.steps} evtName='submitStep' profileSteps={profileSteps} />
          </>
        )}
      </div>
    </div>
  )
}
ProcessFlow.requiresLaunch = true
